import React from 'react';
import MuiCancelIcon from '@material-ui/icons/Cancel';

const CancelIcon = ({ style, ...props }) => (
    <MuiCancelIcon style={{ color: '#6b7785', ...style }} {...props} />
);

export default CancelIcon;
